import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, switchMap, throwError } from 'rxjs';
import { LOGIN, LOGIN_RESET, LOGIN_SUCCESS, LOGOUT } from './login.actions';
import { ApiService } from '../../services/api.service';
import { LoginPayload } from '../../interfaces/login-payload';
import { ILoginState } from './login';
import { setCookie } from '@poste-click-connect/shared-ui';
import { Router } from '@angular/router';
import {
  RETRIEVE_EXPIRED_OBJECT,
  RETRIEVE_NOTIFICATIONS,
  RETRIEVE_REGEX_DHL,
  RETRIEVE_SURVEY,
} from '../config/config.actions';
import { LoginCode } from '../../enums/login-code.enum';
import { Path } from '../../enums/path.enum';
import { HttpErrorResponse } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { ADD_MESSAGE } from '../messages/messages.actions';
import { InterceptorService } from '../../services/interceptor.service';

@Injectable()
export class LoginEffects {
  retrieveProfilerUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LOGIN),
      switchMap(({ body }: { body: LoginPayload }) => this.api.login(body)),
      mergeMap((responseLogin: ILoginState) => {
        const isNavigationAvailable =
          responseLogin.esito === LoginCode.AVAILABLE ||
          responseLogin.esito === LoginCode.CHANGE_PASSWORD;

        if (isNavigationAvailable) {
          const today = new Date();

          const expirationDate = today.getTime() + 500000;
          setCookie(
            'accessToken',
            responseLogin.authToken,
            `${expirationDate}`,
            window.location.hostname
          );
          setCookie(
            'servizi',
            JSON.stringify(responseLogin.servizi),
            `${expirationDate}`,
            window.location.hostname
          );

          if (responseLogin.esito === LoginCode.AVAILABLE) {
            this.router.navigateByUrl('/');
          }
          if (responseLogin.esito === LoginCode.CHANGE_PASSWORD) {
            this.interceptorService.isLoginCambioPassword = true;
            this.router.navigateByUrl(
              `/${Path.GESTIONE_PUNTOPOSTE}/${Path.CAMBIO_PASSWORD}`
            );
          }
        }
        return [
          LOGIN_SUCCESS({ responseLogin }),
          ...(isNavigationAvailable && responseLogin.esito === LoginCode.AVAILABLE
            ? [
                RETRIEVE_NOTIFICATIONS(),
                RETRIEVE_SURVEY(),
                RETRIEVE_REGEX_DHL(),
                RETRIEVE_EXPIRED_OBJECT()
              ]
            : []),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retriveLogout$ = createEffect(() =>
  this.actions$.pipe(
    ofType(LOGOUT),
    switchMap(() => this.api.retriveLogout()),
    mergeMap(() => {
      return [
        LOGIN_RESET(),
      ];
    }),
    catchError((error: HttpErrorResponse) => {
      this.addErrorMessage(error.message)
      return throwError({ error });
    })
  )
);

  constructor(
    private actions$: Actions,
    private api: ApiService,
    private router: Router,
    private store: Store,
    private interceptorService: InterceptorService
  ) {}

  private addErrorMessage(message: string): void {
    this.store.dispatch(ADD_MESSAGE({ message: message }));
  }
}
